<div class="esf-advanced-tooltip -is-open" style="display: block; position: inherit; transform: none;">
  <div *ngIf="image" class="esf-advanced-tooltip__media">
    <img class="esf-advanced-tooltip__image" style="max-width: none;" src="data:image/png;base64,{{ image }}" alt="" />
  </div>
  <div *ngIf="text" class="esf-advanced-tooltip__text">{{ text }}</div>
</div>
